<template>
  <div class="app-main-content">
    <div class="details-view">
      <div style="height: 100%">
        <div style="display: flex;flex-wrap: nowrap;height: 100%;">
          <div class="section" style="width: 25%; background-color: #ffffff">
            <div style="margin-top: 4px;">
              <span
                style="position: absolute; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
              >{{
                '.'
              }}</span>
              <div style="padding-left: 10px;padding-bottom: 5px"> {{ $t('CargoMsg.Cargo_ScenarioSettings') }}</div>
            </div>
            <cargo-ag-grid
              :column-defs="columnDefs"
              :row-data="rowData"
              :grid-options="gridOptions"
              style="width: 100%; margin-top: 12px;"
              @gridReady="params=>{gridApi=params.api}"
            />
          </div>
          <div class="section" style="width: 35%;background-color: #ffffff; position: relative;">
            <div style="margin-top: 4px;">
              <span
                style="position: absolute; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
              >{{
                '.'
              }}</span>
              <div style="padding-left: 10px;padding-bottom: 5px"> {{ $t('CargoMsg.Cargo_ScenarioDescription') }}</div>
            </div>

            <!-- 录音按钮 - 位于整个section的右上角 -->
            <el-button
              v-if="showVoiceButton"
              :type="voiceRecognition.isRecording ? 'danger' : 'default'"
              :disabled="voiceButtonDisabled"
              class="voice-btn-corner"
              :class="{ 'recording': voiceRecognition.isRecording }"
              size="mini"
              @click="handleVoiceButtonClick"
            >
              <span class="voice-btn-content">
                <i v-if="voiceRecognition.isProcessing" class="el-icon-loading custom-loading" />
                <i v-else :class="voiceButtonIcon" />
                <span class="btn-text">{{ voiceButtonText }}</span>
              </span>
            </el-button>
            <div style="display: flex;height: 100%; margin-top: 12px;">
              <div style="height: 100%;width: 82%">
                <el-form
                  label-position="left"
                  label-width="0px"
                  style="height: 100%"
                >
                  <el-form-item label=" " style="height: 100%" class="input-from">
                    <div class="textarea-container">
                      <el-input
                        v-model="task.dataMessage"
                        class="input-border"
                        :filter-chars="false"
                        type="textarea"
                        clearable
                      />

                      <!-- 录音状态指示器 - 位于文本框内部左下角 -->
                      <div v-if="voiceRecognition.isRecording" class="voice-recording-indicator-inner">
                        <i class="el-icon-microphone voice-icon" />
                        <span class="loading-text">{{ $t('CargoMsg.Cargo_VoiceRecording', [voiceRecognition.remainingTime]) }}</span>
                        <div class="voice-wave">
                          <span class="wave-bar" />
                          <span class="wave-bar" />
                          <span class="wave-bar" />
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </el-form>
              </div>
              <div style="width: 18%; padding-top: 20%">
                <div
                  style="display: flex;flex-direction: row;align-content: stretch;align-items: stretch;justify-content: center;"
                >
                  <el-button type="primary" @click="generateScript">{{
                    $t('CargoMsg.Cargo_GenerateScript') + ' >>'
                  }}
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="section" style="width: 40%; background-color: #ffffff">
            <div style="margin-top: 4px;">
              <span
                style="position: absolute; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5"
              >{{
                '.'
              }}</span>
              <div style="padding-left: 10px;padding-bottom: 5px"> {{ $t('CargoMsg.Cargo_DataScript') }}</div>
            </div>
            <div style="height: 50%; margin-top: 12px;">
              <el-form
                label-position="left"
                label-width="0px"
                style="height: 100%"
              >
                <el-form-item label=" " style="height: 100%" class="input-from">
                  <el-input
                    v-model="task.dataScript"
                    :disabled="!isPlatform"
                    class="input-border"
                    :filter-chars="false"
                    type="textarea"
                    clearable
                  />
                </el-form-item>
              </el-form>
            </div>
            <div style="display: flex;padding-top: 5px;padding-bottom: 5px;justify-content: space-between;">
              <div style="display: flex; align-items: center;">
                <span style="position: absolute; padding: 2px;background-color: #169bd5;cursor: pointer; color: #169bd5">{{
                  '.'
                }}</span>
                <div style="padding-left: 10px; display: flex;">
                  {{ $t('CargoMsg.Cargo_DataDisplay') }}
                </div>
              </div>
              <div style="display: flex">
                <span v-if="form.taskScenario === SystemConstants.TASK_SCENARIO_3.code || form.taskScenario === SystemConstants.TASK_SCENARIO_4.code || form.taskScenario === SystemConstants.TASK_SCENARIO_5.code" style="margin:8px 12px 0 0;color: #169bd5">{{ $t('CargoMsg.Cargo_TotalDataCount', [rowsTotal]) }}</span>
                <el-button type="success" @click="previewDataHandler">{{ $t('CargoMsg.Cargo_PreviewData') }}</el-button>
                <el-button
                  v-if="form.taskScenario === SystemConstants.TASK_SCENARIO_1.code"
                  type="primary"
                  @click="debugExecuteHandler"
                >{{
                  $t('CargoMsg.Cargo_DebugExecute')
                }}
                </el-button>
              </div>
            </div>
            <div style="height: 50%; margin-top: 12px;">
              <el-form
                label-position="left"
                label-width="0px"
                style="height: 100%"
              >
                <cargo-ag-grid
                  :column-defs="previewColumnDefs"
                  :row-data="previewData.rowData"
                  :grid-options="previewData.gridOptions"
                  style="width: 100%;height: 100%;"
                  @gridReady="params=>{previewData.gridApi=params.api}"
                />
              </el-form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 开票弹窗 -->
    <invoice-detail-dialog
      v-if="form.taskScenario === SystemConstants.TASK_SCENARIO_1.code && makeInvoiceDialog.visible"
      ref="makeInvoiceDialog"
      :visible.sync="makeInvoiceDialog.visible"
      :title="$t('Invoice.invoice_invoiceInformation')"
      :params="makeInvoiceDialog.params"
      :properties="properties"
      :location="location"
      :look-view="true"
      view-source="tabInvoiceQuery"
      @toStepHandler="toStepHandler"
      @pageChange="pageChange"
    />
  </div>
</template>

<script>

import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { DocumentManage, stringToBool } from '@/utils/commonUtil'
import ColumnUtils from '@/utils/ColumnUtils'
import { commandDetailFunc, taskDetailFunc } from '@/api/sysAutoConfig/sysAutoConfig'
import { ScenarioSettings } from '@/class/model/sys/ScenarioSettings'
import { AutomationConfig } from '@/class/model/sys/AutomationConfig'
import invoiceDetailDialog from '@/views/cargo/v0/Clearing/components/makeInvoice/invoiceDetailDialog.vue'
import { LOG_MAKE_INVOICE, TASK_SCENARIO_3, TASK_SCENARIO_4 } from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import { getNotInvoiceCharges, preGenerateInvoiceFunc, previewDataFunc } from '@/api/clearing/invoice'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { formatNumberToThousands, getUuid } from '@/utils'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import { cache, cacheName } from '@/utils/cacheManager'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { generateScriptFunc } from '@/api/seaExport/intelligentBooking'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import $store from '@/store'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { asrUtils } from '@/utils/asrUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'ScenarioSettings',
  components: { invoiceDetailDialog },
  props: {},
  data() {
    return {
      SystemConstants,
      documentManage: new DocumentManage(),
      activeTabName: 'taskScenario',
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_SerialNo'),
          field: 'serialNumber',
          width: 50
        }, {
          headerName: this.$t('CargoMsg.Cargo_ConditionName'),
          field: 'name',
          editable: true,
          width: 150,
          cellEditor: 'CargoAgGridCommonInputEditor'
        }, {
          headerName: this.$t('CargoMsg.Cargo_Operation'),
          field: 'name',
          width: 100,
          cellRenderer: params => {
            const onAdd = this.documentManage.getPath('onAdd')
            const onDel = this.documentManage.getPath('onDel')
            return `<div>
                        <a onclick="${onAdd}('')" style="color:#1F75D5;font-size:25px;">+</a>
                        <a onclick="${onDel}('${params.data.uuid}','${params.data.serialNumber}')" style="color:#1F75D5;font-size:25px;">-</a>
                      </div>`
          }
        }
      ],
      rowData: [],
      deleteUuids: [],
      location: LOG_MAKE_INVOICE.code,
      addKey: 'addScenario_',
      // 开票/收票弹窗页
      makeInvoiceDialog: {
        visible: false,
        params: {}
      },
      taskList: [],
      // 生成发票
      properties: {
        enableCustomizeRevokeInvoice: false, // 是否作废红冲发票客户化(亚东)
        interfaceName: '', // 纸质发票税控接口类型
        interfaceNameEI: '', // 电子发票税控接口类型
        terminalSn: '', // 百旺开票终端标识
        storageURL: '', // StorageURL
        autoGenerateVoucher: false, // 是否开启水单和发票自动生成凭证功能
        // mode: 0, // 弹窗模式[default:0] 0-开票模式  1-对冲开票模式
        isHedge: false, // 是否对冲
        isAr: true, // 是否应收

        makeInvoiceMethod: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        makeInvoiceMethodHedge: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单

        typeGroup: 'multi', // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票
        invoiceType: 0, // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
        groupingMakeType: 1, // 发票种类：0=纸质发票、1=电子发票

        currencyGroup: 0, // 分币种开票：0=拆分币种开票、1=合并币种
        cbAssignCurrency: true, // 指定发票币种
        groupingCurrencyType: 0, // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
        currency: 'RMB', // 币种

        showChargeDetail: false, // 是否显示费用明细
        useDefaultRate: false, // 按财务汇率开票
        isInvoicingByBillingRate: false, // 按账单汇率
        billingRateMap: {}, // 账单币种、账单汇率
        makeCostInvoice: false, // 生成成本发票
        billPreInvoicing: false, // 根据账单开票要求开票
        isGenCostInvoice: false, // 是否生成成本发票: isAr ? makeCostInvoice : false
        costInvoiceProp: {},
        defaultContent: false, // 将本次内容设置为默认开票信息

        invoiceGoodsName: {}, // 发票项目名称
        settleDepartment: 0, // 结算部门
        settleDepartmentPrefix: '', // 结算部门归属工作号

        otherCurrencys: [], // 其它币种
        otherRates: [], // 其它币种汇率
        txtCurrency1: '',
        txtRate1: '',
        txtCurrency2: '',
        txtRate2: '',
        rateCache: {}, // 对比发票币种的汇率
        cbAlwarysUseRate: false, // 一直按该汇率开票

        branchId: this.$store.getters.currentOfficeId, // 分公司 Session.getInstance().getOfficeId()
        inputByDep: this.$store.getters.currentDeptId, // 部门 Session.getInstance().currentDepartment.departmentId

        titleMap: {}, // 获取账单所对应的结算单位: getTitleMap()
        invoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(entities)
        hedgeInvoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(hedgeEntities)

        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        entities: [], // 开票实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        allCharges: [],
        chargeMap: {},
        invoices: [], // 生成发票列表
        invoice: {}, // 当前发票
        currentPage: 1, // 顺序号
        totalPage: 0, // 发票总数
        invoiceGoodsNameList: [], // 发票项目名称列表
        invoiceItemGoodsName: 0, // InvoiceItemGoodsName：开票发票项目默认货物或应税劳务名称
        defaultGoodsName: '', // InvoiceMergeName：合并开票费用名称
        receivedRadio: 'ALL', // 对冲开票，应收列表币种：全部/RMB/USD
        paymentRadio: 'ALL', // 对冲开票，应付列表币种：全部/RMB/USD
        showChargeDetailByInvoice: false, // ShowChargeDetailByInvoice：增值发票是否可以显示明细
        invoiceNoEditable: false, // InvoiceSearchEdit: 开票查询修改发票号
        costInfo: false, // costSplitInfo: 是否开启费用拆分金额校验
        isInvoicingByBusinessDateRate: false, // 按业务日期汇率收票
        useAutoCheckInvoicing: false, // 是否使用了自动勾选开票
        autoCheckInvoicingAmount: 0.00, // 自动勾选最大金额
        autoCheckInvoiceAmountEnable: false, // 自动勾选最大金额是否可用
        specificConstraintType: '', // 特定约束类型
        settlementCenterMode: false, // 锦昶共享中心
        isInvoicingByTaxRate: false, // 按税点分组开票
        rbgShowChargeDetail: '' // 显示明细
      },
      nbParams: {
        accountId: '',
        passWord: '',
        id: '',
        tokenUrl: '',
        interfaceUrl: '',
        action: '',
        dataScript: ''
      },
      gridApi: null,
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: { CargoAgGridCommonInputEditor },
        onRowClicked: this.onRowClicked
      },
      task: new ScenarioSettings().fillDefaultValue().getData(),
      form: new AutomationConfig().fillDefaultValue().getData(),
      previewData: {
        gridApi: null,
        rowData: [],
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        }
      },

      // 语音识别相关
      voiceRecognition: {
        isRecording: false,
        isProcessing: false,
        currentText: '',
        finalText: '',
        error: null,
        sessionId: null,
        originalInputText: '',
        accumulatedText: '',
        textMerger: null,
        userInputText: '',
        remainingTime: 60,
        timeCounter: null
      },
      rowsTotal: 0,
      // 语音识别管理器实例
      voiceManager: null
    }
  },
  computed: {
    language() {
      return this.$store.getters.language === 'zh'
    },
    previewColumnDefs() {
      let columnDef = []
      if (this.form.taskScenario === SystemConstants.TASK_SCENARIO_2.code) {
        // 发送宁波港交所
        columnDef = [{
          headerName: '', width: 55, checkboxSelection: params => !!params.data, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 100
        },
        { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 100 },
        {
          headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', width: 100,
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        },
        {
          headerName: this.$t('SeaExport.dischargingPort'), field: 'jobDischargingPortCode', width: 100,
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_PlaceOfDelivery'),
          colId: 'jobDeliveryPlace',
          field: 'jobDeliveryPlace',
          width: 150,
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
          }
        },
        {
          headerName: this.$t('Payment.exchangeRate'), field: 'chargeExchangeRate', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 8)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Lane'),
          field: 'jobTransportLine',
          colId: 'jobTransportLine',
          width: 150
        },
        {
          headerName: this.$t('Payment.solicitationType'), field: 'jobCargoSource', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.cargoSourceLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CargoType'),
          field: 'jobCargoType',
          colId: 'jobCargoType',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_CargoType, 'code', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_TransitTerm'),
          field: 'jobFreightTerm',
          colId: 'jobFreightTerm',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.MethodOfPayment'),
          field: 'jobPaymentTermMBL',
          colId: 'jobPaymentTermMBL',
          cellRenderer: (params) => {
            return ColumnUtils.paymentTermLabelFunc(params.value)
          },
          width: 100
        },
        {
          headerName: this.$t('SeaExport.LCL'),
          field: 'jobContainerLoadType',
          colId: 'jobContainerLoadType',
          valueFormatter: (params) => {
            return ColumnUtils.containerLoadTypeLabelFunction(params.data, 'jobContainerLoadType')
          },
          width: 100
        },
        { headerName: this.$t('CargoMsg.Cargo_VesselEnglishName'), field: 'jobVessel', width: 100 },
        { headerName: this.$t('CargoMsg.Cargo_VoyageNo'), field: 'jobVesselFlight', width: 100 },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualSailingTime'), field: 'jobAtd', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EstimatedSailingTime'), field: 'jobEtd', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_CartonQuantity'), field: 'jobContainerDesc', width: 100
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ShippingCompanyName2'), field: 'jobCarrierId', width: 100,
          valueFormatter: (params) => {
            return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_5')
          }
        },
        {
          headerName: this.$t('Payment.remarks'),
          field: 'chargeRemarks',
          width: 100
        },
        {
          headerName: this.$t('SeaExport.ContainerAscription'), field: 'containerAscription', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.yesOrNoFun(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeName'),
          field: 'chargeItemId',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Currency'),
          field: 'chargeCurrency',
          width: 90
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ActualAmount'),
          field: 'chargeAmount',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.number2ColumnLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_UnitPrice'), field: 'chargeUnitRate', width: 180,
          cellRenderer: (params) => {
            return ColumnUtils.numberColumnLabelFunc(params.value, 2, true)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AmountNumber'),
          field: 'chargeQuantity',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceNo'),
          field: 'chargeInvoiceNo',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FeeCreationTime'), field: 'chargeDateCreated', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_FeeModifyDate'), field: 'chargeDateModified', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_InvoiceDate'), field: 'chargeInvoiceDate', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_WriteOffDate'), field: 'chargeClearingDate', width: 100,
          valueFormatter: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ARAP'), field: 'chargeReceivable', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.arApLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChargeStatus'), field: 'chargeState', width: 100, colId: 'chargeState',
          valueFormatter: (params) => {
            return ColumnUtils.chargeStateLabFun(params.value)
          }
        },
        {
          headerName: this.$t('constant.sop.SO_NO'),
          field: 'soNo',
          width: 130
        }
        ]
      } else if (this.form.taskScenario === SystemConstants.TASK_SCENARIO_3.code || this.form.taskScenario === SystemConstants.TASK_SCENARIO_4.code) {
        columnDef = [
          {
            headerName: '', width: 55, checkboxSelection: params => !!params.data, pinned: 'left',
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 100
          },
          {
            headerName: this.$t('SeaExport.EnglishCommodityName'), field: 'jobCargoEnglishName', width: 100
          },
          {
            headerName: this.$t('SeaExport.Marks'),
            field: 'jobMark',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_BLNo'),
            field: 'jobMbl',
            width: 150
          },
          {
            headerName: this.$t('SeaExport.ConsignationCompany'),
            field: 'jobCustomerId',
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
            },
            width: 200
          },
          {
            headerName: 'S/O NO',
            field: 'soNo',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_POL'),
            field: 'jobLoadingPortCode',
            cellRenderer: (params) => {
              if (params.data.jobLob === 'SE') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
              }
              if (params.data.jobLob === 'AE') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
              }
              return ''
            },
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_PortOfDischarge'),
            field: 'jobDischargingPortCode',
            valueFormatter: (params) => {
              if (params.data.jobLob === 'SE') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
              }
              if (params.data.jobLob === 'AE') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
              }
              return ''
            },
            width: 150
          }
        ]
      } else if (this.form.taskScenario === SystemConstants.TASK_SCENARIO_6.code && this.form.dataType === SystemConstants.DATA_TYPE_2.code) {
        columnDef = [
          {
            headerName: '', width: 55, checkboxSelection: params => !!params.data, pinned: 'left',
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 100
          },
          {
            headerName: this.$t('SeaExport.EnglishCommodityName'), field: 'jobCargoEnglishName', width: 100
          },
          {
            headerName: this.$t('SeaExport.Marks'),
            field: 'jobMark',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_BLNo'),
            field: 'jobMbl',
            width: 150
          },
          {
            headerName: this.$t('SeaExport.ConsignationCompany'),
            field: 'jobCustomerId',
            valueFormatter: (params) => {
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_0') : ''
            },
            width: 200
          },
          {
            headerName: 'S/O NO',
            field: 'jobSoNo',
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_POL'),
            field: 'jobLoadingPortCode',
            cellRenderer: (params) => {
              if (params.data.jobLob === 'SE') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
              }
              if (params.data.jobLob === 'AE') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
              }
              return ''
            },
            width: 150
          },
          {
            headerName: this.$t('CargoMsg.Cargo_PortOfDischarge'),
            field: 'jobDischargingPortCode',
            valueFormatter: (params) => {
              if (params.data.jobLob === 'SE' || params.data.jobLob === 'SI') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'auto_7')
              }
              if (params.data.jobLob === 'AE') {
                return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'auto_8')
              }
              return ''
            },
            width: 150
          },
          {
            headerName: 'ETD', field: 'jobEtd',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, width: 120
          },
          {
            headerName: 'ETA', field: 'jobEta',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, width: 120
          }
        ]
      } else {
        columnDef = [
          {
            headerName: '', width: 55, checkboxSelection: params => !!params.data, pinned: 'left',
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('Invoice.invoice_businessNumber'), field: 'jobNo',
            width: 150
          },
          {
            headerName: this.$t('Invoice.invoice_settlementCompany'), field: 'accountId',
            cellRenderer: (params) => {
              return CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId')
            }, width: 180
          },
          {
            headerName: this.$t('Invoice.invoice_customer'), field: 'jobCustomerId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }, width: 180
          },
          {
            headerName: this.$t('Invoice.invoice_businessType'), field: 'jobLob',
            cellRenderer: (params) => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            }, width: 120
          },
          {
            headerName: this.$t('Invoice.invoice_paymentType'), field: 'isReceivable',
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(stringToBool(params.value))
            }, width: 120
          },
          {
            headerName: this.$t('Invoice.invoice_businessDate'), field: 'jobBusinessDate',
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }, width: 120
          },
          {
            headerName: this.$t('Invoice.invoice_chargeItem'), field: 'chargeItemId',
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
            }, width: 130
          },
          { headerName: this.$t('Invoice.invoice_currency'), field: 'currency', width: 100 },
          { headerName: this.$t('Invoice.invoice_quantity'), field: 'quantity', width: 100 },
          {
            headerName: this.$t('Invoice.invoice_taxIncludedPrice'), field: 'amount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 120
          },
          {
            headerName: this.$t('Invoice.invoice_taxExcludedPrice'), field: 'excludingTaxAmount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 120
          },
          { headerName: this.$t('FinanceManage.charge_taxRate'), field: 'taxRate', width: 100 },
          {
            headerName: this.$t('Invoice.invoice_taxAmount'), field: 'taxAmount',
            cellRenderer: (params) => {
              return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value), 2)
            }, width: 100
          },
          {
            headerName: this.$t('constant.sop.SO_NO'),
            field: 'soNo',
            width: 130
          }
        ]
      }
      return columnDef
    },
    isPlatform() {
      return this.$store.getters.isPlatform
    },

    // 语音按钮文本
    voiceButtonText() {
      if (this.voiceRecognition.isRecording) {
        return this.voiceRecognition.isProcessing ? this.$t('CargoMsg.Cargo_VoiceRecognizing') : this.$t('CargoMsg.Cargo_VoiceStopRecording')
      }
      return this.$t('CargoMsg.Cargo_VoiceStartRecording')
    },

    // 语音按钮图标
    voiceButtonIcon() {
      if (this.voiceRecognition.isRecording) {
        return this.voiceRecognition.isProcessing ? 'el-icon-loading' : 'el-icon-video-pause'
      }
      return 'el-icon-microphone'
    },

    // 语音按钮禁用状态
    voiceButtonDisabled() {
      return this.voiceRecognition.isProcessing
    },

    // 语音按钮显示控制
    showVoiceButton() {
      // 当开票弹窗显示时隐藏录音按钮
      if (this.makeInvoiceDialog.visible) {
        return false
      }

      // 如果语音管理器未初始化，隐藏按钮
      if (!this.voiceManager) {
        return false
      }

      return true
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onAdd', function() {
      context.onAdd()
    })
    this.documentManage.set('onDel', function(value, value2) {
      context.onDel(value, value2)
    })
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    await this.initConfig()

    // 初始化语音识别
    this.initVoiceRecognition()
  },

  beforeDestroy() {
    // 清理语音识别资源
    this.stopTimeCounter()
    if (this.voiceManager) {
      try {
        this.voiceManager.cleanup()
      } catch (error) {
        console.error('[语音识别] 组件销毁时清理失败:', error)
      }
    }
  },
  methods: {
    async onShow(action, form, refresh = true) {
      this.$emit('refreshDone', 'scenarioSettings')
      if (!refresh) {
        return
      }
      this.rowsTotal = 0
      this.rowData = []
      this.deleteUuids = []
      if (this.gridApi) {
        this.gridApi.clearFocusedCell()
      }
      this.form = form
      PriceUtils.resetFilter(this.nbParams)
      PriceUtils.resetFilter(this.properties)
      if (form && form.uuid && !form.uuid.includes(this.addKey)) {
        // 加载场景
        this.loadData(form.uuid)
      } else {
        this.onAdd()
        this.selectOne()
      }
    },
    async initConfig() {
      this.properties.invoiceItemGoodsName = Number(cache.config.get('InvoiceItemGoodsName'))
      this.properties.defaultGoodsName = String(cache.config.get('InvoiceMergeName'))
      this.properties.showChargeDetailByInvoice = String(cache.config.get('ShowChargeDetailByInvoice')) === '1'
      this.properties.invoiceNoEditable = String(cache.config.get('InvoiceSearchEdit')) === '1'
      this.properties.costInfo = Number(cache.config.get('costSplitInfo')) === 1
      this.properties.enableCustomizeRevokeInvoice = Number(cache.config.get('enableCustomizeRevokeInvoice')) === 1
      this.properties.interfaceName = String(cache.config.get('TaxControlInterfaceName'))
      this.properties.interfaceNameEI = String(cache.config.get('EITaxControlInterfaceName'))
      this.properties.terminalSn = String(cache.config.get('baiWangOriginTerminalSN'))
      this.properties.storageURL = String(cache.config.get('StorageURL'))
      this.properties.isInvoiceByEachBillingRate = Number(cache.config.get('isInvoiceByEachBillingRate')) === 1
      this.properties.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.properties.toExoSystemHC = String(cache.config.get('ToExoSystem')) === 'HC' // 海创
      this.properties.QdWarning = String(cache.config.get('QdWarning')) !== '0' // 全电接口-国税应急方案
      this.properties.FeiByAuth = Number(cache.config.get('FeiByAuth')) === 1 // 全电接口是否走实人认证
      this.properties.settlementCenterMode = String(cache.config.get('SettlementCenterMode')) === '1' // 锦昶共享中心
      this.properties.isEasyInoivceVietnam = this.properties.interfaceNameEI === InvoiceConstant.INVOICE_EASY_INOIVCE_VIETNAM // 杰贝越南税控
      this.properties.isBillPreInvoicing = String(cache.config.get('BillingNoteContainInvoiceReques')) // 太平账单预开发票
    },
    loadData(uuid) {
      if (!uuid) {
        return
      }
      taskDetailFunc({ uuid: uuid }).then(res => {
        this.rowData = res.data
        if (!this.rowData || this.rowData.length === 0) {
          this.onAdd()
        }
        this.$nextTick(() => {
          this.selectOne()
          this.rowClicked()
        })
        ColumnUtils.addSerialNumber(this.rowData)
      })
      commandDetailFunc({ uuid: uuid }).then(res => {
        this.taskList = res.data
      })
    },
    selectOne() {
      const nodes = this.gridApi ? (this.gridApi.getRenderedNodes() || []) : []
      // 默认选中第一个
      for (const item of nodes) {
        this.task = item.data
        if (!this.form.uuid) {
          PriceUtils.resetFilter(this.task)
        }
        item.setSelected(true)
        this.gridApi.setFocusedCell(0)
        break
      }
    },
    refreshProperties(data) {
      if (data) {
        if (this.form.taskScenario === SystemConstants.TASK_SCENARIO_2.code) {
          this.nbParams = data
          this.task.propertiesData = { ...data }
        } else {
          this.properties = data
          this.task.propertiesData = { ...data }
          this.form.applyRuleToAll = data.applyRuleToAll
          if (data.applyRuleToAll) {
            for (const t of this.rowData) {
              t.propertiesData = { ...data }
            }
          }
        }
        this.$emit('taskChange', this.task)
      }
    },
    refreshTask(data) {
      if (data) {
        this.taskList = data
      }
    },
    onAdd() {
      const newConfiguration = new ScenarioSettings().fillDefaultValue().getData()
      newConfiguration.serialNumber = 0
      if (this.form.taskScenario === SystemConstants.TASK_SCENARIO_2.code) {
        newConfiguration.propertiesData = this.nbParams
      } else {
        newConfiguration.propertiesData = this.properties
      }
      newConfiguration.uuid = this.addKey + getUuid()
      this.rowData.push(newConfiguration)
      ColumnUtils.addSerialNumber(this.rowData)
    },
    onDel(uuid, serialNumber) {
      if (uuid !== null) {
        if (!this.deleteUuids) {
          this.deleteUuids = []
        }
        this.deleteUuids.push(uuid)
      }
      const data = this.rowData.filter(item => item.serialNumber === Number(serialNumber))
      if (data && data.length > 0) {
        this.rowData.splice(serialNumber - 1, 1)
      }
      if (this.rowData.length === 0) {
        this.onAdd()
      } else {
        ColumnUtils.addSerialNumber(this.rowData)
      }
      this.$nextTick(() => {
        this.selectOne()
        this.rowClicked()
      })
    },
    // 退出详情
    toStepHandler(data) {
      this.makeInvoiceDialog.visible = false
    },
    // 切换发票
    pageChange(data) {
      console.log('pageChange:', data)
      //
      this.properties.totalPage = this.properties.invoices.length
      if (this.properties.currentPage > this.properties.totalPage) {
        this.properties.currentPage = this.properties.totalPage
      }
      if (this.properties.currentPage < 1) {
        this.properties.currentPage = 1
      }
      //
      if (this.properties.totalPage > 0) {
        this.properties.invoice = this.properties.invoices[this.properties.currentPage - 1]
        // 增票合并/显示明细
        if (this.properties.invoice.ar && [2, 3, 6, 7].includes(this.properties.invoice.invoiceType)) {
          this.properties.rbgShowChargeDetail = 'merge'
          for (const invoiceItem of this.properties.invoice.invoiceItemList) {
            if (invoiceItem.goodsName.indexOf('\n') > -1) {
              this.properties.rbgShowChargeDetail = 'detail'
            }
          }
        } else if (this.properties.invoice.ar && [0, 1, 4].includes(this.properties.invoice.invoiceType)) {
          this.properties.rbgShowChargeDetail = 'merge'
          if (!StrUtils.isEmpty(this.properties.invoice.partAmount) && this.properties.invoice.partAmount.indexOf('\n') > -1) {
            this.properties.rbgShowChargeDetail = 'detail'
          }
        }
        console.log('invoice', this.properties.invoice)
        //
        this.$refs.makeInvoiceDialog.initBaseData()
      }
    },
    // 预览数据
    previewDataHandler() {
      this.previewData.rowData = []
      if (!this.task.dataScript) {
        return
      }
      const loading = getLoading()
      previewDataFunc({ anyStr: this.task.dataScript }).then(res => {
        this.rowsTotal = 0
        if (res.data) {
          this.rowsTotal = res.data.length
        }
        console.log('res.data ', res.data)
        this.previewData.rowData = res.data
      }).finally(() => {
        loading.close()
      })
    },
    // 调试执行开票
    async debugExecuteHandler() {
      // 如果正在录音，先停止录音
      if (this.voiceRecognition.isRecording && this.voiceManager) {
        try {
          await this.stopVoiceRecognition()
        } catch (error) {
          console.warn('[调试执行] 停止录音失败:', error)
        }
      }

      const rows = this.previewData.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('SystemMaintenance.PleaseCheckOneEntry'))
        return
      }
      if (!Object.keys(this.task.propertiesData).length) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ConfirmRuleSettings'))
        return
      }
      const keys = rows.map((item) => item.uuid)
      await getNotInvoiceCharges({ 'keys': keys }).then(res => {
        this.properties.entities = res.data
        this.doDebugExecuteHandler()
      })
    },
    async doDebugExecuteHandler() {
      this.properties.allEntities = []
      const allCharges = []
      const chargeMap = {}
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      if (makeInvoiceMethod === 1) {
        for (const item of this.properties.entities) {
          const charges = []
          if (this.properties.isGenCostInvoice && item.isOversea && !item.isReceivable) {
            continue
          }
          // CARGO-17790，H5开票界面使用按记录开票类型错误
          if (item['entity'] === 'charge' || item.entity === undefined) {
            allCharges.push(item)
            if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2) {
              charges.push(item.uuid)
              chargeMap['charge-' + item.uuid] = charges
            }
          }
        }
      }
      if (this.taskList && this.taskList.length > 0) {
        for (const task of this.taskList) {
          if (task.commandName === 'invoicing' && task.dataScript &&
            task.dataScript.toUpperCase().includes('invoiceAmount>0'.toUpperCase())) {
            this.properties.canNotInvoice = true
            break
          }
        }
      }
      this.properties.allCharges = allCharges
      this.properties.chargeMap = chargeMap
      this.properties.allEntities.push(...this.properties.entities)
      // 接口中开票类型：mode
      this.properties.mode = this.properties.typeGroup
      this.properties.autoInvoice = true
      // titleMap
      this.properties.titleMap = {}
      // invoiceByType
      this.properties.invoiceByType = 'charge'
      // hedgeInvoiceByType
      this.properties.hedgeInvoiceByType = 'charge'
      if (this.properties.isGenCostInvoice) {
        const costInvoiceProp = {}
        for (const prop in this.properties) {
          costInvoiceProp[prop] = this.properties[prop]
        }
        // 开票模式
        costInvoiceProp['mode'] = 'multi'
        // 开票类型
        costInvoiceProp['invoiceType'] = 4 // 4=内部发票
        costInvoiceProp['groupingCurrencyType'] = 4
        this.properties['costInvoiceProp'] = costInvoiceProp
      }
      // 多币种相关
      await this.checkState()
      const requestBody = {
        'chargeMap': this.properties.chargeMap,
        'properties': this.properties,
        'location': this.location
      }
      const loading = getLoading4Cxt(this)
      preGenerateInvoiceFunc(requestBody).then(res => {
        if (res.data && res.data.length > 0) {
          this.properties.invoices = res.data
          this.properties.currentPage = 1
          this.makeInvoiceDialog.visible = true
          setTimeout(() => {
            this.pageChange()
          }, 100)
        } else {
          this.$message.warning(this.$t('CargoMsg.Cargo_NoDataToPreview'))
        }
      }).finally(() => {
        loading.close()
      })
    },
    onRowClicked(event) {
      this.task = event.data
      this.rowClicked()
    },
    rowClicked() {
      if (this.form.taskScenario === SystemConstants.TASK_SCENARIO_2.code) {
        this.nbParams = this.task.propertiesData
      } else {
        this.properties = this.task.propertiesData
      }
      this.previewData.rowData = []
      this.$emit('taskChange', this.task)
    },
    // 生成脚本
    generateScript() {
      if (!this.task.dataMessage) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseFill') + this.$t('CargoMsg.Cargo_ScenarioDescription'))
        return
      }
      const loading = getLoading4Cxt(this)
      const tenantId = $store.getters.tenantId
      let params = tenantId + '-queryInvoice'
      if (this.form.taskScenario === SystemConstants.TASK_SCENARIO_2.code) {
        params = tenantId + '-querySendToExchange'
      }
      if (this.form.taskScenario === SystemConstants.TASK_SCENARIO_3.code || this.form.taskScenario === SystemConstants.TASK_SCENARIO_4.code || this.form.taskScenario === SystemConstants.TASK_SCENARIO_5.code) {
        params = tenantId + '-query' + this.form.taskScenario
      }
      if (this.form.taskScenario === SystemConstants.TASK_SCENARIO_6.code) {
        params = tenantId + '-querySendDataToPlatform'
      }
      generateScriptFunc({ anyStr: this.task.dataMessage, anyStr1: params }).then(res => {
        this.task.dataScript = res.data
      }).finally(() => {
        loading.close()
      })
    },
    async checkState() {
      this.properties.otherCurrencys = []
      this.properties.otherRates = []
      this.properties.rateCache = {}
      console.log('checkState:', this.properties.allEntities)
      // 开票方式: 1=费用、2=业务、3=账单、4=对账单、5=付款申请单
      const makeInvoiceMethod = this.properties.makeInvoiceMethod
      // 记录每笔账单/对账单/付款申请单的开票总金额(开票方式为账单/对账单/付款申请单，向上汇总开票金额)
      const invoiceAmountMap = new Map()
      if (makeInvoiceMethod === 1 || makeInvoiceMethod === 2 || makeInvoiceMethod === 3 || makeInvoiceMethod === 4 || makeInvoiceMethod === 5) {
        for (const charge of this.properties.allEntities) {
          if (charge.currency !== this.properties.currency) {
            const cacheKey = 'InvoiceRate-' + charge.currency + '-' + this.properties.currency + '-' + (this.properties.isAr ? 1 : 0)
            if (!this.properties.rateCache[charge.currency] && this.properties.cbAlwarysUseRate && LocalStorageUtilsNew.hasConfiguration(cacheKey) && !this.properties.isInvoicingByBillingRate) {
              this.properties.rateCache[charge.currency] = LocalStorageUtilsNew.getConfiguration(cacheKey)
            } else if (!this.properties.rateCache[charge.currency]) {
              // CARGO-882，账单汇率相同时，支持选择按账单汇率开票
              if (this.properties.isInvoicingByBillingRate) {
                if (this.properties.billingRateMap[charge.currency]) {
                  this.properties.rateCache[charge.currency] = this.properties.billingRateMap[charge.currency]
                } else {
                  this.properties.rateCache[charge.currency] = await RateUtil.getForeignExchangeRateSafely(this.properties.currency, charge.currency, new Date(), 0)
                }
              } else if (this.properties.isInvoicingByBusinessDateRate) { // 按业务日期汇率收票
                this.properties.rateCache[charge.currency] = await RateUtil.getForeignExchangeRateSafely(this.properties.currency, charge.currency, charge.jobBusinessDate, 0, 12, false)
              } else {
                this.properties.rateCache[charge.currency] = await RateUtil.getForeignExchangeRateSafely(this.properties.currency, charge.currency, new Date(), 0)
              }
            }
            if (makeInvoiceMethod === 3 && this.properties.isInvoicingByBillingRate && this.properties.isInvoiceByEachBillingRate && this.properties.billingRateMap2[charge.currency + charge.billingUuid]) {
              charge.invoiceRate = this.properties.billingRateMap2[charge.currency + charge.billingUuid]
            } else {
              charge.invoiceRate = this.properties.rateCache[charge.currency]
            }
            // charge.invoiceAmount2 = NumberUtils.roundHalfUp(charge.invoiceRate * charge.amount, 2)
            charge.invoiceAmount2 = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(charge.invoiceRate * charge.amount, this.properties.currency), 2)
          } else {
            charge.invoiceRate = 1
            charge.invoiceAmount2 = charge.amount
          }
          if (charge['entity'] === 'charge') {
            let uuid = '' // 列表父节点的UUID
            if (makeInvoiceMethod === 3) {
              uuid = charge['billingUuid']
            } else if (makeInvoiceMethod === 4) {
              uuid = charge['billingGroupUuid']
            } else if (makeInvoiceMethod === 5) {
              uuid = charge['billingPaymentUuid']
            }
            if (invoiceAmountMap.has(uuid)) {
              // invoiceAmountMap.set(uuid, invoiceAmountMap.get(uuid) + (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2)
              invoiceAmountMap.set(uuid, RateUtil.getAmountByCurrency(invoiceAmountMap.get(uuid) + (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2, this.properties.currency))
            } else {
              invoiceAmountMap.set(uuid, (charge.receivable === this.properties.isAr ? 1 : -1) * charge.invoiceAmount2)
            }
          }
          if (charge.currency !== this.properties.currency && this.properties.otherCurrencys.indexOf(charge.currency) === -1) {
            this.properties.otherCurrencys.push(charge.currency)
          }
        }
      }
      this.showCurrency()

      this.properties.otherRates = []
      if (this.properties.otherCurrencys.length > 2) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NECDFTIC').format(2))
        return
      } else if (this.properties.otherCurrencys.length > 0) {
        const n1 = parseFloat(this.properties.txtRate1)
        if (!this.properties.txtRate1 || n1 === 0) {
          this.$message.warning(this.$t('Message.PleaseEnterCurrencyExchangeRate'))
          return
        }
        this.properties.otherRates.push(this.properties.txtRate1)
        if (this.properties.otherCurrencys.length > 1) {
          const n2 = parseFloat(this.properties.txtRate2)
          if (!this.properties.txtRate2 || n2 === 0) {
            this.$message.warning(this.$t('Message.PleaseEnterCurrencyExchangeRate'))
            return
          }
          this.properties.otherRates.push(this.properties.txtRate2)
        }
      }
    },
    showCurrency() {
      this.properties.txtCurrency1 = ''
      this.properties.txtRate1 = ''
      this.properties.txtCurrency2 = ''
      this.properties.txtRate2 = ''
      //
      if (this.properties.otherCurrencys.length > 0) {
        this.properties.txtCurrency1 = this.properties.otherCurrencys[0]
        this.properties.txtRate1 = this.changeInfinity(this.properties.rateCache[this.properties.txtCurrency1])
      }
      if (this.properties.otherCurrencys.length > 1) {
        this.properties.txtCurrency2 = this.properties.otherCurrencys[1]
        this.properties.txtRate2 = this.changeInfinity(this.properties.rateCache[this.properties.txtCurrency2])
      }
    },
    changeInfinity(value) {
      if (value === Infinity) {
        return ''
      }
      return NumberUtils.formatNumber(value, 8)
    },
    async getSubmitData() {
      for (const data of this.rowData) {
        if (data.uuid.includes(this.addKey)) {
          data.uuid = ''
        }
      }
      return {
        deleteUuids: this.deleteUuids,
        taskDetails: this.rowData
      }
    },

    // 初始化语音识别
    async initVoiceRecognition() {
      try {
        // 检查浏览器兼容性
        const compatibility = asrUtils.checkCompatibility()
        console.log('[语音识别] 浏览器兼容性检查:', compatibility)

        if (!compatibility.mediaDevices || !compatibility.mediaRecorder || !compatibility.audioContext) {
          console.warn('[语音识别] 浏览器不支持语音识别功能')
          return
        }

        this.voiceManager = asrUtils.createManager()

        // 设置回调函数
        this.voiceManager.onError = this.handleVoiceError
        this.voiceManager.onStateChange = this.handleVoiceStateChange
        this.voiceManager.onTextUpdate = this.handleVoiceTextUpdate
        this.voiceManager.onTimeLimit = this.handleVoiceTimeLimit

        console.log('[语音识别] 初始化成功')
      } catch (error) {
        console.error('[语音识别] 初始化失败:', error)
      }
    },

    // 语音按钮点击处理
    async handleVoiceButtonClick() {
      if (!this.voiceManager) {
        this.$message.error(this.$t('CargoMsg.Cargo_VoiceNotInitialized'))
        return
      }

      if (this.voiceRecognition.isRecording) {
        await this.stopVoiceRecognition()
      } else {
        await this.startVoiceRecognition()
      }
    },

    // 开始语音识别
    async startVoiceRecognition() {
      try {
        this.voiceRecognition.isProcessing = true
        this.voiceRecognition.error = null
        this.voiceRecognition.currentText = ''

        // 保存录音开始前的用户真实输入内容
        this.voiceRecognition.originalInputText = this.task.dataMessage || ''
        this.voiceRecognition.accumulatedText = ''

        // 初始化时间计数器
        this.voiceRecognition.remainingTime = 60
        this.startTimeCounter()

        // 检查浏览器支持
        if (!(await this.voiceManager.isSupported())) {
          throw new Error(this.$t('CargoMsg.Cargo_VoiceBrowserNotSupported'))
        }

        // 开始录音，传入当前输入文本作为基础
        await this.voiceManager.startRecognition(this.voiceRecognition.originalInputText)

        this.voiceRecognition.isRecording = true
        this.voiceRecognition.isProcessing = false

        this.$message.success(this.$t('CargoMsg.Cargo_VoiceStartRecordingTip'))
      } catch (error) {
        this.stopTimeCounter()
        this.voiceRecognition.isProcessing = false
        this.handleVoiceError(error)
      }
    },

    // 停止语音识别
    async stopVoiceRecognition() {
      try {
        this.voiceRecognition.isProcessing = true
        this.stopTimeCounter()

        const finalText = await this.voiceManager.stopRecognition()

        // 重置状态但保留最终文本
        this.resetVoiceRecognitionState()
        this.voiceRecognition.finalText = finalText

        // 最终文本已通过onTextUpdate回调更新到输入框
        this.$message.success(this.$t('CargoMsg.Cargo_VoiceRecordingEnd'))
      } catch (error) {
        // 发生错误时恢复原始输入内容
        this.task.dataMessage = this.voiceRecognition.originalInputText

        // 重置状态
        this.resetVoiceRecognitionState()

        this.handleVoiceError(error)
      }
    },

    // 处理文本更新
    handleVoiceTextUpdate(mergedText, isFinal) {
      console.log('[语音识别] 文本更新:', mergedText, '最终:', isFinal)

      // 实时更新输入框内容
      this.task.dataMessage = mergedText

      // 更新内部状态
      if (isFinal) {
        this.voiceRecognition.finalText = mergedText
        this.voiceRecognition.currentText = ''
      } else {
        this.voiceRecognition.currentText = mergedText
      }

      // 记录累积文本
      this.voiceRecognition.accumulatedText = mergedText
    },

    // 处理语音识别状态变化
    handleVoiceStateChange(state) {
      console.log('[语音识别] 状态变化:', state)

      // 更新本地状态
      Object.assign(this.voiceRecognition, {
        isRecording: state.isRecording,
        isProcessing: state.isProcessing,
        currentText: state.currentText,
        finalText: state.finalText,
        sessionId: state.sessionId
      })
    },

    // 处理语音识别错误
    handleVoiceError(error) {
      console.error('[语音识别] 错误:', error)

      this.voiceRecognition.error = error.message || error.userMessage || this.$t('CargoMsg.Cargo_VoiceRecognitionError')
      this.$message.error(this.voiceRecognition.error)

      // 完全重置状态
      this.resetVoiceRecognitionState()
    },

    // 重置语音识别状态
    resetVoiceRecognitionState() {
      this.voiceRecognition.isRecording = false
      this.voiceRecognition.isProcessing = false
      this.voiceRecognition.currentText = ''
      this.voiceRecognition.error = null
      this.voiceRecognition.sessionId = null
      this.stopTimeCounter()
    },

    // 处理语音识别时间限制
    handleVoiceTimeLimit() {
      console.log('[语音识别] 达到60秒录音时间限制')
      this.stopTimeCounter()
      this.$message.warning(this.$t('CargoMsg.Cargo_VoiceTimeLimitReached'))
    },

    // 启动时间计数器
    startTimeCounter() {
      this.voiceRecognition.timeCounter = setInterval(() => {
        if (this.voiceRecognition.remainingTime > 0) {
          this.voiceRecognition.remainingTime--
        } else {
          this.stopTimeCounter()
        }
      }, 1000)
    },

    // 停止时间计数器
    stopTimeCounter() {
      if (this.voiceRecognition.timeCounter) {
        clearInterval(this.voiceRecognition.timeCounter)
        this.voiceRecognition.timeCounter = null
      }
    }
  }
}
</script>
<style lang="scss">
.app-main-content {

  .input-from {
    .el-form-item__content {
      width: 100%;
      height: 100%;
    }
  }

  .input-border {
    height: 100%;

    .el-textarea__inner {
      width: 100%;
      height: 100%;
    }
  }

  .general-pagination {
    .el-pager {
      li.number.active {
        color: blue !important;
      }
    }
  }

  // 语音识别相关样式
  .textarea-container {
    position: relative;
    height: 100%;
  }

  // 右上角录音按钮样式
  .voice-btn-corner {
    position: absolute !important;
    top: 6px !important;
    right: 19% !important;
    z-index: 9999 !important;
    font-size: 11px !important;
    padding: 4px 8px !important;
    height: 28px !important;
    min-height: 28px !important;
    width: auto !important;
    min-width: 60px !important;
    max-width: none !important;
    margin: 0 !important;
    transform: none !important;
    transition: all 0.3s ease;
    box-sizing: border-box !important;

    // 自定义loading图标样式
    .custom-loading {
      animation: rotating 2s linear infinite;
      margin-right: 4px;
    }

    &:hover {
      transform: translateY(-1px);
    }

    &.recording {
      animation: pulse 2s infinite;
      box-shadow: 0 0 10px rgba(245, 108, 108, 0.5);

      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 0 15px rgba(245, 108, 108, 0.8);
      }
    }

    .voice-btn-content {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 3px;
      width: 100%;
      height: 100%;

      .btn-text {
        font-size: 11px;
        margin-left: 2px;
        white-space: nowrap;
      }
    }
  }

  // 录音状态指示器（文本框内部）
  .voice-recording-indicator-inner {
    position: absolute;
    bottom: 8px;
    left: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 8px;
    background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
    border: 1px solid #fecaca;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    z-index: 10;
    font-size: 12px;

    .voice-icon {
      color: #dc2626;
      font-size: 14px;
      animation: pulse-icon 2s infinite;
    }

    .loading-text {
      color: #dc2626;
      font-weight: 500;
      white-space: nowrap;
    }

    .voice-wave {
      display: flex;
      align-items: center;
      gap: 2px;

      .wave-bar {
        width: 2px;
        height: 8px;
        background: #dc2626;
        border-radius: 1px;
        animation: wave 1.5s infinite ease-in-out;

        &:nth-child(1) {
          animation-delay: 0s;
        }

        &:nth-child(2) {
          animation-delay: 0.2s;
        }

        &:nth-child(3) {
          animation-delay: 0.4s;
        }
      }
    }
  }
}

// 动画效果
@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 0 10px rgba(245, 108, 108, 0.5);
  }
  50% {
    transform: scale(1.02);
    box-shadow: 0 0 15px rgba(245, 108, 108, 0.8);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 10px rgba(245, 108, 108, 0.5);
  }
}

@keyframes pulse-icon {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

@keyframes wave {
  0%, 100% {
    height: 6px;
    opacity: 0.4;
  }
  50% {
    height: 12px;
    opacity: 1;
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
